import React from 'react';
import { Modal } from '../../../../Components/uielements';

import {
  OutlineButton,
  ModalButtonWrapper,
  ModalGap,
} from '../../../../services/settings/appStyle/global.style';
import { ModalWrapper } from '../group.style';
import { ModalLabel } from '../../UserV2/user.style';

const ViewGroupMembers = ({ onClose, groupMembers }) => {
  return (
    <Modal isOpen={true} title="Group Members">
      <ModalWrapper>
        <ModalGap>
          {groupMembers &&
            groupMembers?.userArray &&
            groupMembers.userArray.map((member, index) => (
              <ModalLabel key={index}>
                {member?.firstName} {member?.lastName}
              </ModalLabel>
            ))}
        </ModalGap>

        <ModalButtonWrapper>
          <OutlineButton onClick={onClose}>Close</OutlineButton>
        </ModalButtonWrapper>
      </ModalWrapper>
    </Modal>
  );
};

export default ViewGroupMembers;
